import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "stepper-buttom" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Próximo passo ")
const _hoisted_3 = { class: "stepper-container" }
const _hoisted_4 = { class: "stepper-indicator" }

import { defineComponent, ref } from "vue";

type stepperProps = {
  currentStep?: number;
  stepperLength?: number;
  stepperDisabled?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Stepper',
  props: {
    currentStep: null,
    stepperLength: null,
    stepperDisabled: { type: Boolean }
  },
  emits: {
  stepperChanges: (step) => step,
  stepperFinish: (step) => step,
},
  setup(__props: any, { emit }) {

const {
  currentStep = 1,
  stepperLength,
  stepperDisabled,
} = __props as {
  currentStep?: number;
  stepperLength?: number;
  stepperDisabled?: boolean;
}

defineComponent({
  name: "Stepper",
});





const step = ref(currentStep);

const handleNextClick = (_stepperLength: number) => {
  if (step.value === _stepperLength) {
    emit("stepperFinish", step.value);
    return;
  }

  step.value++;
  emit("stepperChanges", step.value);
};

const handlePrevClick = () => {
  if (step.value === 1) {
    return;
  }
  step.value--;
  emit("stepperChanges", step.value);
};

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "stepper-btn-back text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handlePrevClick()))
      }, _toDisplayString(`<< VOLTAR`)),
      _createVNode(_component_n_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleNextClick(__props.stepperLength))),
        disabled: __props.stepperDisabled
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.stepperLength, (index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["stepper-stage", { 'stepper-active': step.value === index }])
          }, null, 2))
        }), 256))
      ])
    ])
  ], 64))
}
}

})